<template>
  <div class="searchZrbhdPage">
    <div class="searchTit clearfix">
      <a href="javascript:void(0);" class="fl" @click="goBack">
        <van-icon name="arrow-left" />
      </a>
      <p>{{$t("searchMsg.searchZrbhd")}}</p>
    </div>
    <div class="searchBox">
      <van-cell-group>
        <van-field
          v-model="searchValue.year"
      
          :label="$t('common.yearTit') + '：'"
          :placeholder="$t('searchMsg.searchTit')"
          readonly
          center
          @click="yearsPicker = true"
        ></van-field>
        <van-field
          v-model="searchArea"
          :label="$t('common.politicalTit') + '：'"
          :placeholder="$t('searchMsg.searchTit')"
          readonly
          center
          @click="areaShowPicker = true"
          class="searchType"
        ></van-field>
        <van-button type="primary" size="small" @click="reloadResultList">{{
          $t("common.search")
        }}</van-button>
      </van-cell-group>
    </div>
    <div :class="['searchMain',this.showNonePage == true ? 'hideText' : '']">
      <van-list
        v-model="loading"
        :finished="finished"
        @load="onLoad"
        :offset="100"
        :finished-text="$t('common.noneMore')"
        class="resultList"
      >
        <van-cell v-for="item in resultData" :key="item.id" class="item" @click="setMap(item)">
          <p class="clearfix">
            {{item.name}}
            <span class="fr">{{item.yztNd}}</span>
          </p>
          <p class="clearfix">{{$t('common.type')}}：{{item.type}}</p>
          <p class="clearfix">{{$t('common.politicalTit')}}：{{item.address}}</p>
        </van-cell>
      </van-list>
      <!-- 无数据显示 -->
      <div class="nonePage" v-if="showNonePage">
        <img :src="nonePng" alt />
        <p>{{ $t("common.noDataTip") }}</p>
      </div>
    </div>
    <!-- 弹出层 -->
    <!-- 年度选择 -->
    <van-popup v-model="yearsPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="yearsSelectList"
        value-key="name"
        :cancel-button-text="$t('searchMsg.clearText')"
        @cancel="onClearYears"
        @confirm="onSaveYears"
      />
    </van-popup>
    <!-- 省、市、县/区、乡/镇、村两级联动 -->
    <van-popup v-model="areaShowPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="citys"
        value-key="zqName"
        :cancel-button-text="$t('searchMsg.clearText')"
        @cancel="onClearArea"
        @confirm="onSaveArea"
      />
    </van-popup>

    <!-- 自然保护地详情 弹框 -->
    <div class="zrbhdStyle" v-if="showZrbhdType">
      <div class="zgc">
        <a href="javascript:void(0);" @click="closePage">
          <i class="van-icon van-icon-arrow-left"></i>
        </a>
        <p>详情</p>
      </div>
      <!-- 自然保护地详情 -->
      <zrbhdMsg :param="{id:this.dataInfo.objid,type:this.dataInfo.type,showMap:false}" />
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
import zrbhdMsg from "../universal/zrbhdMsg";
import { getaeraList, setYearList } from "@/utils/common";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
import nonePng from "@/assets/none.png";
import { mapState } from "vuex";
export default {
  name: "searchZrbhd",
  data() {
    return {
      editType: true,
      searchArea: "", //查询的城区名
      nonePng: nonePng, //默认图片
      showNonePage: false, //
      searchValue: {
        year: "", //年度
        zqCode: "", //城市区域码
        selectType: "2"
      }, //搜索值
      yearsPicker: false,
      yearsSelectList: [],
      areaShowPicker: false, //
      citys: [],
      resultData: [],
      backstagelists: [],
      page: 0,
      pageSize: 10,
      commentCount: 0,
      loading: false, //是否处于加载状态
      finished: false, //是否已加载完所有数据
      isLoading: false, //是否处于下拉刷新状态
      showZrbhdType: false, //是否显示自然保护第详情
      dataInfo: "", //向子组件传值
      clientType: "" //手机类型
    };
  },
  mounted() {
    this.clientType = getDeviceType();
    this.$nextTick(() => {
      if (this.userinfo && this.searchObj) {
        this.initPage();
        this.getCitys();
      }
    });
  },
  components: {
    zrbhdMsg
  },
  methods: {
    async getCitys() {
      this.yearsSelectList = await setYearList();
      this.citys = await getaeraList(this.searchObj.zqCode?this.searchObj.zqCode:this.userinfo.zqCode);
    },
    initPage() {
      if (
        this.userinfo &&
        this.searchObj &&
        this.searchObj.objid &&
        this.userinfo.zqCode
      ) {
        this.$set(this.searchValue, "gridType", this.searchObj.zrqlx);
        this.$set(this.searchValue, "objid", this.searchObj.objid);
        this.$set(this.searchValue, "zqCode", this.searchObj.zqCode?this.searchObj.zqCode:this.userinfo.zqCode);
        this.getTest();
      }
    },
    getTest() {
      let _this = this;

      if (_this.page != 0 && this.page * 10 >= parseInt(_this.commentCount)) {
        return;
      }
      _this.page += 1;
      _this.$api.search
        .resourceBaohudiList(_this.page, _this.pageSize, _this.searchValue)
        .then(res => {
          if (res.code == "1") {
            let total = parseInt(res.data.total);
            _this.commentCount = total;
            _this.backstagelists = res.data.list;
            _this.viewLists();
            // 加载状态结束
            _this.loading = false;
            if (_this.page * 10 >= total) {
              _this.finished = true;
              _this.editType = true;
              console.log("加载完成");
            }
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch(err => {
          this.refreshPage = true;
          console.log(err);
        });
    },
    viewLists() {
      this.resultData = this.resultData.concat(this.backstagelists);
      if (this.resultData.length < 1) {
        this.showNonePage = true;
      } else {
        this.showNonePage = false;
      }
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.getTest();
      }, 500);
    },
    reloadResultList() {
      let _this = this;
      if (_this.editType) {
        _this.showNonePage = false;
        _this.editType = false;
        _this.loading = true; //是否处于加载状态
        _this.finished = false;
        _this.searchValue.zqCode == ""
          ? (_this.searchValue.zqCode = _this.searchObj.zqCode?_this.searchObj.zqCode:_this.userinfo.zqCode)
          : (_this.searchValue.zqCode = _this.searchValue.zqCode);
        (_this.page = 0), (_this.pageSize = 10), (_this.commentCount = 0);
        _this.resultData = [];
        _this.getTest();
      } else {
        _this.$toast(_this.$t("common.moreClickToastMsg"));
      }
    },
    //选择时间
    onSaveYears(data) {
      console.log(data);
      this.searchValue.year = data.name;
      this.yearsPicker = false;
    },
    //清除时间条件
    onClearYears(data) {
      this.searchValue.year = "";
      this.yearsPicker = false;
    },
    onSaveArea(value, index) {
      //保存的政区
      this.searchArea = value[0] + value[1];
      let indexOne = index[0];
      let indexTwo = index[1];
      this.searchValue.zqCode = this.citys[indexOne].children[indexTwo].zqCode;
      this.areaShowPicker = false;
    },
    onClearArea(value, index) {
      //清空政区内容
      this.searchArea = "";
      this.searchValue.zqCode = "";
      this.areaShowPicker = false;
    },
    goBack() {
      let _this = this;
      this.$store.commit("SetcloseShowType", "open");
      _this.$emit("changeType", true);
    },
    setMap(data) {
      // 接口信息未提供objid
      this.dataInfo = {
        objid: data.objid,
        type: "geo_baohudi"
      };
      this.showZrbhdType = true;
      this.$store.commit("SetcloseShowType", "close");
      this.$emit("getMapOptions", this.dataInfo);
    },
    closePage() {
      //关闭详情页
      this.showZrbhdType = false;
      this.$store.commit("SetcloseShowType", "open");
    }
  },
  computed: {
    ...mapState(["userinfo", "searchObj"])
  },
  watch: {
    userinfo: {
      handler: function() {
        let _this = this;
        // this.searchValue.zqCode = userinfo.zqCode;
        // _this.getTest();
        if (this.userinfo && this.searchObj) {
          _this.initPage();
        }
      },
      deep: true
    },
    searchObj: {
      handler: function() {
        let _this = this;
        // let splitText = _this.searchObj.zrqlx.substring(4, 8);
        // if (splitText == "grid") {
        // _this.searchValue.gridType = _this.searchObj.zrqlx;
        // _this.searchValue.objid = _this.searchObj.objid;
        // }
        if (this.userinfo && this.searchObj) {
          _this.initPage();
        }
      },
      deep: true
    }
  }
};
</script>
<style lang="less">
.searchZrbhdPage {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  position: relative;
  .searchTit {
    width: 100%;
    padding: 0 16px;
    height: 35px;
    background-color: #fff;
    position: relative;

    a {
      display: inline-block;
      width: 55px;
      padding-left: 15px;
      line-height: 35px;
      font-size: 14px;
      color: #4bc08a;
      position: relative;

      .van-icon {
        position: absolute;
        left: 0;
        top: 11px;
        display: inline-block;
        font-size: 14px;
        color: #4bc08a;
        font-weight: 600;
      }
    }

    p {
      width: 200px;
      line-height: 35px;
      margin: 0 auto;
      color: #666;
      text-align: center;
      font-size: 14px;
    }
  }

  .searchBox {
    width: 100%;
    position: relative;
    .van-cell {
      width: 100%;
      height: 46px;
      padding: 8px 16px;
      box-sizing: border-box;

      .van-field__label {
        color: #666;
        font-size: 12px;

        span {
          line-height: 30px;
        }
      }

      .van-cell__value {
        .van-field__control {
          color: #333;
          font-size: 12px;
          line-height: 30px;
        }
      }
    }

    .searchType.van-cell {
      width: 80%;
    }

    .van-button {
      position: absolute;
      right: 16px;
      bottom: 9px;
    }
  }

  .searchMain {
    width: 100%;
    height: 75%;
    overflow-y: scroll;
    background-color: #f6f6f6;
    position: relative;
    .resultList {
      width: 100%;
      padding: 0 8px;

      .item {
        width: 100%;
        background-color: #fff;
        margin: 10px 0;
        padding: 8px 8px;
        border-radius: 8px;
        -webkit-border-radius: 8px;
        -moz-borer-radius: 8px;

        p {
          color: #636464;
          font-size: 12px;
          line-height: 20px;
          margin-bottom: 10px;
        }

        p:first-child {
          font-size: 14px;
          font-weight: 600;

          span {
            float: right;
            font-size: 10px;
            font-weight: 400;
          }
        }
      }
    }
    .nonePage {
      width: 120px;
      height: 150px;

      position: absolute;
      left: 50%;
      margin-left: -60px;
      top: 50%;
      margin-top: -75px;

      img {
        display: block;
        max-width: 100px;
        max-height: 100px;
        margin: 0 auto;
      }

      p {
        margin-top: 10px;
        text-align: center;
        color: #5c5d5d;
        font-size: 16px;
      }
    }
  }
  .searchMain.hideText {
    .van-list__finished-text {
      display: none;
    }
  }

  .zrbhdStyle {
    position: absolute;
    width: 100%;
    height: calc(100% - 1px);
    top: 0;
    left: 0;
    padding-top: 40px;
    background-color: #f6f6f6;
    .zgc {
      position: absolute;
      width: 100%;
      height: 40px;
      line-height: 40px;
      background-color: #fff;
      z-index: 9999 !important;
      top: 0;
      left: 0;
      font-size: 15px;
      text-align: center;
      color: #646566;
      a {
        display: inline-block;
        width: 45px;
        color: #4bc08a;
        position: absolute;
        left: 16px;
        top: 0px;
        text-align: left;
        .van-icon {
          line-height: 40px;
          display: inline-block;
          font-size: 14px;
          color: #4bc08a;
          font-weight: 600;
        }
      }
    }
  }
}
</style>